import React from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import internalStateService from "../../app/InternalStateService";
import LoadingAnimationHOC from "@tinqin/tinqin-ui-components/src/loading-animation/LoadingAnimationHOC";

const getGlobalLoadingSelector = state => {
    return state.getIn(["global", "globalLoading"]);
};

const loadingProps = () => {
    let defaultData = {
        minLoadingTime: 0,
        contentRenderWaitingTime: 0,
        fadeinTime: 0,
        fadeoutTime: 500
    };
    if (internalStateService.getComponentsDefaultConfig()["globalLoading"]) {
        return Object.assign(
            defaultData,
            internalStateService.getComponentsDefaultConfig()["globalLoading"]
        );
    } else return defaultData;
};

const mapStateToProps = createSelector([getGlobalLoadingSelector], isLoading => {
    return { isLoading };
});

export const GlobalLoadingAnimation = (props) => {

        let visible;
        let status = props.status;
        let Preloader = internalStateService.getComponent("preloader");
        switch (status) {
            case "show":
            case "waitContentRender":
            case "fadein":
            case "fadeout":
                visible = true;
                break;
            default:
                //status "hide" or "wait"
                visible = false;
                break;
        }
        let className = document.body.className || "";
        if (visible) {
            if (!className.includes("tq-global-preloader-active")) {
                if (className !== "") {
                    document.body.className = className + " tq-global-preloader-active";
                } else document.body.className = className + "tq-global-preloader-active";
            }
            let customContent;
            if (props.preloaderType) {
                customContent = internalStateService.getComponent("preloaderTypes")[
                    props.preloaderType
                ];
            }
            return <Preloader customContent={customContent} {...props} global />;
        } else if (className.includes(" tq-global-preloader-active")) {
            document.body.className = className.replace(" tq-global-preloader-active", "");
        } else if (className.includes("tq-global-preloader-active")) {
            document.body.className = className.replace("tq-global-preloader-active", "");
        }

        return <></>;
}

GlobalLoadingAnimation.displayName = "GlobalLoading"; //minification concern

export default connect(mapStateToProps)(LoadingAnimationHOC(GlobalLoadingAnimation, loadingProps));
